import _ from 'lodash'
import type { CssContext, CompSpecificData } from '../features/componentCss.types'
import { mergeVisibilityTransformations } from '../features/commonCssData/visibilityTransformationsCompNode'

export const accumulateCssContext: (
	compId: string,
	cssContext: CssContext,
	compSpecificData?: CompSpecificData
) => CssContext = (
	compId,
	{ getParent, isInRepeater, patterns, visibilityTransformations, isMobileView, isSlot },
	compSpecificData
) => {
	return {
		isMobileView,
		isInRepeater,
		isSlot,
		getParent,
		patterns: _.merge(patterns, compSpecificData?.patterns),
		visibilityTransformations: mergeVisibilityTransformations(
			visibilityTransformations,
			compSpecificData?.visibilityTransformations
		),
	}
}
